import React from 'react'
import { Navigate } from 'react-router'

import { useCurrentCompanyUser } from '../../hooks/useCurrentCompanyUser'
import { ROUTES } from '../../lib/routes'

interface Props {
  children: React.ReactNode
}

const CompanyAdminGuard: React.FC<Props> = ({ children }) => {
  const companyUser = useCurrentCompanyUser()

  return companyUser?.isCompanyAdmin ? (
    <>{children}</>
  ) : (
    <Navigate to={ROUTES.index} />
  )
}

export default CompanyAdminGuard
